import type { EventKind, IProgram } from '../../api/src/programs';
import type { RecordBatch } from '../lists/RecordWriter';
import { asksReceived, countedFrom, deadlinesFor, eventLabel, type IEventInput } from './events';
import type { RecordSet } from './FirmRecords';
import type { IApplicationView } from './model';

/**
 * Records a letter or event on a file, and the deadlines that follow it (calculated, unconfirmed).
 * A rule whose date the letter sets is added only when the person entered that date. How each date
 * was reached (which date it was counted from, the other period staff ticked) is kept with the
 * deadline and written to History.
 */
export async function recordEvent(records: RecordSet, batch: RecordBatch, a: IApplicationView, program: IProgram, kind: EventKind, input: IEventInput, note: string | undefined): Promise<void> {
  const label: string = eventLabel(kind);
  const from = countedFrom(kind, input);
  if (!from) {
    throw new Error('Enter a date first.');
  }
  const letterDate: string | undefined = input.letterDate || undefined;
  const receivedDate: string | undefined = asksReceived(kind) ? input.receivedDate || undefined : undefined;
  const dates: string = [letterDate ? `dated ${letterDate}` : '', receivedDate ? `received ${receivedDate}` : ''].filter(x => x).join(', ');
  const ev = await batch.create(records.events, {
    Title: label, ApplicationKey: a.key, Kind: kind, EventDate: letterDate ?? receivedDate, ReceivedDate: receivedDate, Note: note
  }, label, `Recorded "${label}" (${dates}) on ${a.title}`);
  for (const l of deadlinesFor(program, kind, input)) {
    if (l.due) {
      await batch.create(records.events, {
        Title: l.label, ApplicationKey: a.key, Kind: 'deadline', EventKey: ev.key, EventDate: from.date, Due: l.due, RuleId: l.ruleId, RuleSource: l.source
      }, l.label, `Added the deadline "${l.label}" (${l.due}, ${l.calculated ? 'calculated' : 'from the letter'}; to be checked). ${l.how}`.trim());
    }
  }
}
